import axios from 'axios';
import store from '../redux/store/store';
const userToken = store.getState()?.auth?.user?.accessToken?.token;
// API URL'si environment değişkenlerinden alınıyor
const API_PRODUCTATTRIBUTE_URL = import.meta.env.VITE_API_URL;

const productAttribute = {

  fetchProductAttribute: async (productId) => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;
      const response = await axios.get('/ProductAttribute', {
        params: {
          withAttributeValue:true,
          productId: productId,
        },headers:{  Authorization: `Bearer ${userToken}`}
      });
      
      return response?.data?.data;
    } catch (error) {
      console.error('Error fetching attributes:', error);
      throw error;
    }
  },

  deleteProductAttributes: async (ids) => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;
      const params = new URLSearchParams();
      ids.forEach(id => params.append('ids', id));
  
      const response = await axios.delete('ProductAttribute/DeleteRange', { params,headers:{  Authorization: `Bearer ${userToken}`} });
      return response;
    } catch (error) {
      console.error('Error deleting attributes:', error);
      throw error;
    }
  },
  
 
}
export default productAttribute;
